
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Systemmanufactures() {



  const cardData =
  {
    keyword: 'Patient Warming System Manufacturers',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming System Manufacturers',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading manufacturer ofPatient Warming System Manufacturers, providing advanced thermal care solutions for hospitals and surgical centers across India. Our convection warmer blankets utilize forced-air technology to deliver consistent, controlled heat, effectively preventing perioperative hypothermia and enhancing patient safety. Designed with cutting-edge features, our blankets ensure uniform heat distribution, are easy to operate, and integrate seamlessly into various clinical settings. Trusted by healthcare professionals nationwide, Pharmacle Health Care is convection patient warmer blankets are the optimal choice for reliable and efficient patient temperature management.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Leading Patient Warming System Manufacturers for Surgical and Critical Care",
    "description": "Pharmacle Health Care is recognized as one of the foremost manufacturers of patient warming systems, providing hospitals and clinics with advanced thermal solutions that ensure precise temperature control. Our systems are designed to reduce the risk of hypothermia during surgeries and critical care, promoting faster patient recovery and improved clinical outcomes."
  },
  {
    "title": "Advanced Patient Warming System Manufacturer in India",
    "description": "As a leading Indian manufacturer, Pharmacle Health Care delivers high-performance patient warming systems built with the latest technology. Our devices support medical staff in maintaining normothermia across a wide range of medical procedures, ensuring better safety, comfort, and results for patients in surgical and intensive care environments."
  },
  {
    "title": "Top Manufacturer of High-Efficiency Patient Warming Equipment",
    "description": "Pharmacle Health Care manufactures state-of-the-art patient warming systems that combine intelligent temperature sensors with user-friendly interfaces. Our products are trusted by medical institutions for their reliability and ability to provide consistent heat delivery, making them essential for operation theaters, emergency wards, and post-operative care units."
  },
  {
    "title": "Trusted Supplier and Manufacturer of Patient Warming Devices",
    "description": "With a strong focus on innovation and clinical safety, Pharmacle Health Care offers patient warming devices that meet international standards. Our systems are crafted to enhance patient safety during procedures, ensuring the body temperature remains stable through controlled and effective warming methods."
  },
  {
    "title": "Patient Warming System Manufacturer Backed by Research and Quality",
    "description": "Driven by a commitment to healthcare excellence, Pharmacle Health Care manufactures patient warming systems that undergo rigorous quality checks and clinical validation. Our solutions are engineered to support surgical efficiency, minimize recovery time, and lower the chances of temperature-related complications in patients."
  },
  {
    "title": "Reliable and Affordable Patient Warming Systems by Industry Experts",
    "description": "Pharmacle Health Care stands out for offering cost-effective yet technologically advanced patient warming systems. Manufactured with precision and clinical insight, our systems are tailored for use in high-demand hospital environments, ensuring reliability and performance without compromise."
  },
  {
    "title": "Innovative Thermal Care Systems from India’s Trusted Manufacturer",
    "description": "Our patient warming solutions feature intuitive controls, efficient energy consumption, and adaptable blanket configurations. Pharmacle Health Care supports healthcare providers with tools that help maintain optimal body temperatures during complex and extended surgical procedures."
  },
  {
    "title": "Custom-Built Patient Warming Solutions for Modern Healthcare",
    "description": "Pharmacle Health Care manufactures customizable patient warming systems to cater to diverse clinical needs. Whether it’s for pediatric, trauma, or general surgical applications, our systems deliver safe and consistent thermal support, empowering healthcare professionals to improve patient care delivery."
  },
  {
    "title": "Nationwide Supplier of Surgical Patient Warming Systems",
    "description": "Our warming systems are used in leading hospitals across India, thanks to our nationwide distribution network and commitment to customer satisfaction. Pharmacle Health Care is proud to be a top manufacturer and supplier, helping facilities maintain high standards of patient care."
  },
  {
    "title": "Pharmacle Health Care – Manufacturer of Choice for Patient Warming Equipment",
    "description": "From innovation to execution, Pharmacle Health Care has established itself as the manufacturer of choice for patient warming equipment in India. With durable build quality, intuitive features, and clinical accuracy, our systems are trusted across specialties including general surgery, orthopedics, gynecology, and cardiovascular care."
  }
],

"services": [
    {
        "name": "Patient Warming System Manufacturers",
        "description": "Pharmacle Health Care is a leading manufacturer of patient warming systems, designed to maintain optimal body temperature during medical procedures. Our systems are equipped with advanced technology to prevent hypothermia and ensure patient safety and comfort. We offer customized solutions for hospitals, surgical centers, and healthcare facilities, providing reliable temperature management to improve patient outcomes across a range of medical treatments."
    },
    {
        "name": "India Medical Warming Systems",
        "description": "We provide state-of-the-art medical warming systems in India, designed to regulate body temperature during surgeries, recovery, and critical care. These systems utilize advanced technology to deliver precise thermal management, preventing temperature-related complications such as hypothermia. Trusted by healthcare professionals, our systems ensure safe and comfortable environments for patients in hospitals and medical centers."
    },
    {
        "name": "Surgical Patient Warming Equipment",
        "description": "Our surgical patient warming equipment is designed to regulate body temperature during surgical procedures. These devices are critical for preventing hypothermia, ensuring patient safety, and improving surgical outcomes. Pharmacle Health Care’s warming equipment is easy to use, reliable, and equipped with advanced features to ensure consistent and accurate temperature management throughout the surgical process."
    },
    {
        "name": "Forced Air Warming Systems",
        "description": "We offer forced air warming systems designed to provide consistent and reliable temperature regulation during medical treatments. These systems use advanced technology to circulate warm air around the patient, ensuring they remain at a safe and comfortable body temperature during surgeries, recovery, and critical care. Trusted by healthcare providers across India, our forced air warming systems ensure patient safety and comfort."
    },
    {
        "name": "Patient Temperature Management Systems",
        "description": "Pharmacle Health Care provides patient temperature management systems designed to maintain a safe body temperature during medical procedures. These systems are essential for preventing hypothermia and thermal instability, especially during surgery and critical care. With precision control and easy-to-use features, our temperature management systems help healthcare professionals deliver optimal care and improve patient recovery outcomes."
    },
    {
        "name": "Operating Room Warming Machines",
        "description": "Our operating room warming machines are designed to maintain optimal body temperature for patients during surgery. These machines ensure controlled and consistent warmth, reducing the risk of hypothermia and improving surgical outcomes. With advanced technology and easy-to-use functionality, Pharmacle Health Care's operating room warming machines are vital for maintaining patient comfort and safety in the operating room."
    },
    {
        "name": "Hospital Body Warming Devices",
        "description": "We provide hospital body warming devices designed to regulate body temperature during medical procedures. These devices are critical for ensuring patient comfort and preventing temperature-related complications. Our hospital warming devices are trusted by healthcare facilities across India for their reliability and effectiveness in maintaining patient safety throughout surgeries, recovery, and critical care."
    },
    {
        "name": "Patient Thermal Regulation Systems",
        "description": "Pharmacle Health Care offers patient thermal regulation systems that are essential for maintaining a safe and consistent body temperature during medical treatments. These systems are designed to prevent hypothermia, promote patient comfort, and ensure recovery. With advanced sensors and control mechanisms, our thermal regulation systems are an essential part of healthcare equipment in hospitals and medical centers."
    },
    {
        "name": "Clinical Warming Equipment India",
        "description": "We provide clinical warming equipment in India, designed to regulate body temperature during medical procedures, including surgeries, critical care, and recovery. Our clinical warming equipment helps prevent temperature-related complications and ensures a safe and comfortable environment for patients. With high reliability and precision, these devices are essential tools for medical professionals in delivering effective patient care."
    }
],
"tableData": [
    ["- Patient Warming System Manufacturers", "- India Medical Warming Systems"],
    ["- Surgical Patient Warming Equipment", "- Forced Air Warming Systems"],
    ["- Patient Temperature Management Systems", "- Operating Room Warming Machines"],
    ["- Hospital Body Warming Devices", "- Patient Thermal Regulation Systems"],
    ["- Clinical Warming Equipment India"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As leading Patient Warming System Manufacturers, we offer advanced warming technology designed to provide precise temperature control during medical procedures. Our systems are reliable, helping prevent hypothermia and ensuring optimal patient safety and comfort."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of Patient Warming Systems that cater to various medical needs. Our solutions include warming devices, blankets, and temperature control systems, ensuring that patients remain comfortable and safe throughout their treatments."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warming Systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Each system is rigorously tested to ensure optimal functionality and reliability in demanding healthcare settings."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "The safety and comfort of patients are our top priorities. Our Patient Warming Systems are designed to provide controlled, gentle warmth, preventing temperature-related complications during surgeries and medical procedures."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Systems are adaptable to a wide range of healthcare settings, including operating rooms, recovery units, and patient wards. We work closely with healthcare providers to ensure our systems meet their specific needs."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Our Patient Warming Systems are designed for easy integration with existing medical systems. Whether you are updating an existing setup or building a new one, our systems can be quickly deployed without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services to help healthcare facilities select the right Patient Warming Systems for their needs. Our team provides ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the heart of everything we do. Our Patient Warming Systems are designed to prevent temperature-related issues during critical medical procedures, ensuring the best possible care for patients."
    }
]


















  }

  const faqData = [
    {
      question: "Who are the leading Patient Warming System manufacturers?",
      answer: "Pharmacle Health Care Private Limited is one of the leading Patient Warming System manufacturers, offering advanced medical devices that help regulate and maintain patient body temperature during surgeries and recovery."
    },
    {
      question: "What types of Patient Warming Systems does Pharmacle Health Care manufacture?",
      answer: "Pharmacle Health Care manufactures Forced Air Warming Systems that include warm air blowers and compatible warming blankets or pads, designed for safe and efficient heat distribution."
    },
    {
      question: "Why are Patient Warming Systems important in medical procedures?",
      answer: "Patient Warming Systems help prevent hypothermia during surgery, reduce the risk of complications, improve recovery times, and enhance overall patient comfort and safety."
    },
    {
      question: "Are Pharmacle Health Care's Patient Warming Systems suitable for all hospitals?",
      answer: "Yes, Pharmacle’s systems are designed to be compatible with a wide range of clinical and surgical settings, making them suitable for small clinics to large multi-specialty hospitals."
    },
    {
      question: "Does Pharmacle Health Care provide installation and support services?",
      answer: "Yes, Pharmacle Health Care offers full support including system installation, training for medical staff, and ongoing maintenance to ensure optimal performance of the Patient Warming Systems."
    }
  ];
  
  const testimonialsData = [
    {
      text: "We’ve been using Patient Warming Systems from Pharmacle Health Care in our surgical department and have seen a clear improvement in patient outcomes and post-op comfort.",
      name: "Dr. Ravi Deshmukh, Lifeline Surgical Center"
    },
    {
      text: "Pharmacle’s warming systems are reliable and easy to operate. Their service team has also been very responsive and supportive.",
      name: "Grace Medical Hospital"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming System Manufacturers",
    "description": "Leading Patient Warming System Manufacturers in India offering advanced medical warming systems, forced air warming equipment, and clinical temperature management solutions to enhance patient care in hospitals and surgical settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1321"
    }
  };
 
  

  

  return (
    <div>
 
 <Helmet>
    <title>Patient Warming System Manufacturers | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Top Patient Warming System Manufacturers in India providing hospital body warming devices, forced air warming systems, and surgical temperature management equipment. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming System Manufacturers, India Medical Warming Systems, Surgical Patient Warming Equipment, Forced Air Warming Systems, Patient Temperature Management Systems, Operating Room Warming Machines, Hospital Body Warming Devices, Patient Thermal Regulation Systems, Clinical Warming Equipment India"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/49.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Systemmanufactures;